import $ from 'jquery'
import { VueEventTracker } from './vueEventTracker'
export { sendEvent, GbAnalyticsPlugin }

let GbAnalyticsPlugin = new VueEventTracker(sendEvent)

/*
 * name: Event name, conventionally a verb followed by subject (e.g. Viewed Goal, Clicked Button)
 * data: object containing properties for the event
 * options: object containing content analytics properties (e.g. cu for content uuid, ct for content title). These are typically used for quicksight analytics
 */
function sendEvent(name, evtData = {}, options) {
  const analyticsEndpoint = `${process.env.VUE_APP_EVENTS_URL}/event`
  const data = Object.assign({}, evtData, {
    location: window.location.pathname,
    window_location: window.location.toString(),
  })

  // create event, merging in options
  var baseEvent = {
    n: name,
    data: data,
    src: 'toolkit',
    com: 'frontend',
    t: new Date(),
    l: new Date(),
  }
  const event = { ...baseEvent, ...options }

  $.ajax(analyticsEndpoint, {
    cache: false,
    type: 'POST',
    contentType: 'application/json; charset=UTF-8',
    data: JSON.stringify(event),
  }).catch((err) => {
    console.warn(err)
  })

  console.log(`Sent Event: ${name}, ${data.location}`)
}
